// Do not modify this file by hand!
// Re-generate this file by running lit-localize

import { str } from '@lit/localize';

/* eslint-disable no-irregular-whitespace */
/* eslint-disable @typescript-eslint/no-explicit-any */

export const templates = {
  s02ea2ba04ac778bf: str`Retour au portail`,
  s03c75db6e18f29d2: str`Se connecter`,
  s98512c9b90146e3c: str`Icone du portail`,
};
